import ResendEmail from "./ResendEmail.container";

export default ResendEmail;